var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-tabs',[_c('v-tab',{attrs:{"to":{name: this.$ROUTER_NAMES.PAYMENTS_ORDERS}}},[_vm._v("Orders")]),_c('v-tab',{attrs:{"to":{name: this.$ROUTER_NAMES.PAYMENTS_PLANS}}},[_vm._v("Plans")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }